import { LineAddedArgs } from './../../layout/line-added-args';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { FieldValueChangedArgs } from 'src/app/layout/field-value-changed-args';
import { LayoutService } from 'src/app/layout/layout.service';
import * as Handlebars from 'handlebars';

export class StockTransfer {
  constructor(
    private layoutService: LayoutService,
    private messageService: NzMessageService,
    private modal: NzModalService
  ) {
    layoutService.fieldValueChanged.subscribe((args: FieldValueChangedArgs) => {
      if (args.recordProperty === undefined) return;
      try {
        this.executeFieldChanged(args);
      } catch (e) {
        console.log(
          'An error occured while trying to execute executeStockTransferFieldChanged',
          args,
          e
        );
      }
    });

    this.layoutService.lineAdded.subscribe((args: LineAddedArgs) => {
      try {
        this.executeLineAdded(args);
      } catch (e) {
        console.log(
          'An error occured while trying to execute lineAdded',
          args,
          e
        );
      }
    });
  }

  executeLineAdded(args: LineAddedArgs) {
    if (args.section.XmlTagName === 'StockTransfer_Lines') {
      const stockTransfer = args.recordModel.Categories.find(
        (s) => s.Id === 'StockTransfer'
      );

      const fromWarehouse = stockTransfer.Lines[0].Properties.find(
        (p) => p.Name === 'FromWarehouse'
      );
      const toWarehouse = stockTransfer.Lines[0].Properties.find(
        (p) => p.Name === 'ToWarehouse'
      );

      args.recordLine.Properties.find(
        (p) => p.Name === 'FromWarehouse'
      ).ValueAsObject = fromWarehouse.ValueAsObject;
      args.recordLine.Properties.find(
        (p) => p.Name === 'WarehouseCode'
      ).ValueAsObject = toWarehouse.ValueAsObject;
    }
  }

  executeFieldChanged(args: FieldValueChangedArgs) {
    if (
      args.recordProperty.Name === 'FromWarehouse' &&
      args.sectionTagName === 'StockTransfer'
    ) {
      const lines = args.recordModel.Categories.find(
        (s) => s.Id === 'StockTransfer_Lines'
      );
      if (lines.Lines.length === 0) {
        return;
      }

      this.modal.confirm({
        nzTitle: this.layoutService.translate(
          'Do you want to change the [warehouse from] for all existing lines?'
        ),
        nzContent: '',
        nzOnOk: () => {
          lines.Lines.forEach((l) => {
            l.Properties.find((p) => p.Name === 'FromWarehouse').ValueAsObject =
              args.recordProperty.ValueAsObject;

            const sectionOfField = args.moduleStructure.module.Sections.find(
              (d) => d.XmlTagName === 'StockTransfer_Lines'
            );
            if (
              sectionOfField.AdditionalInformationParsed.LineTemplate !== '' &&
              sectionOfField.AdditionalInformationParsed.LineTemplate != null &&
              sectionOfField.AdditionalInformationParsed.LineTemplate !==
                undefined
            ) {
              const template = Handlebars.compile(
                sectionOfField.AdditionalInformationParsed.LineTemplate
              );
              const html = template(l);
              l.LineTemplateHtml = html;
            }
          });
        },
      });
    } else if (
      args.recordProperty.Name === 'ToWarehouse' &&
      args.sectionTagName === 'StockTransfer'
    ) {
      const lines = args.recordModel.Categories.find(
        (s) => s.Id === 'StockTransfer_Lines'
      );
      if (lines.Lines.length === 0) {
        return;
      }

      this.modal.confirm({
        nzTitle: this.layoutService.translate(
          'Do you want to change the [warehouse to] for all existing lines?'
        ),
        nzContent: '',
        nzOnOk: () => {
          lines.Lines.forEach((l) => {
            l.Properties.find((p) => p.Name === 'WarehouseCode').ValueAsObject =
              args.recordProperty.ValueAsObject;
            const sectionOfField = args.moduleStructure.module.Sections.find(
              (d) => d.XmlTagName === 'StockTransfer_Lines'
            );
            if (
              sectionOfField.AdditionalInformationParsed.LineTemplate !== '' &&
              sectionOfField.AdditionalInformationParsed.LineTemplate != null &&
              sectionOfField.AdditionalInformationParsed.LineTemplate !==
                undefined
            ) {
              const template = Handlebars.compile(
                sectionOfField.AdditionalInformationParsed.LineTemplate
              );
              const html = template(l);
              l.LineTemplateHtml = html;
            }
          });
        },
      });
    }
  }
}
